import {
  Box,
  Flex,
  Icon,
  Progress,
  Text,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import IconBox from "components/icons/IconBox";
import React from "react";
import { MdMovieFilter, MdDownload } from "react-icons/md";
import banner from "assets/img/nfts/Nft7.png";
import useProfileService from "services/profileService"; 

export default function Banner(props) {
  const { used, total } = props;
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const textColorSecondary = "gray.400";
  const box = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  
  const { downloadFile } = useProfileService();
    

  const handleDownload = async () => {
    try {
      await downloadFile();
    } catch (error) {
      console.error('Download failed:', error);
    }
  };
  
  return (
    <Card 
      bgImage={banner} 
      mb={{ base: "0px", lg: "20px" }} 
      display="flex"
      flexDirection="column"
      alignItems="center"
      pt="54px"
      pb="24px"
    >
      <IconBox
        mx="auto"
        h="100px"
        w="100px"
        icon={
          <Icon as={MdMovieFilter} color={brandColor} h="46px" w="46px" />
        }
        bg={box}
      />
      <Text 
        color="white" 
        fontWeight="bold" 
        fontSize="2xl" 
        mt="20px"
        textAlign="center"
      >
        Pack 20 managers
      </Text>
      <Text
        color={textColorSecondary}
        fontSize="md"
        fontWeight="bold"
        maxW={{ base: "100%", xl: "80%", "3xl": "60%" }}
        mx="auto"
        textAlign="center"
      >
        Programme de développement sur 12 mois
      </Text>
      
      <Button
        leftIcon={<MdDownload color="#4318FF" />} // Set icon color to match text
        bg="white"
        color="#4318FF"
        variant="solid"
        size="md"
        mt="4"
        onClick={handleDownload}
        _hover={{ 
          bg: "whiteAlpha.900",
          transform: "scale(1.02)",
        }}
        transition="all 0.2s"
        boxShadow="0px 2px 5px rgba(0, 0, 0, 0.1)"
      >
        Consulter le calendrier
      </Button>

      <Box w="100%" mt="auto" px="24px">
        <Flex w="100%" justify="space-between" mb="10px">
          <Text color="white" fontWeight="bold" fontSize="sm">
            {used}%
          </Text>
          <Text color="white" fontWeight="bold" fontSize="sm">
            100%
          </Text>
        </Flex>
        <Progress
          align="start"
          colorScheme="brandScheme"
          value={(used / total) * 100}
          w="100%"
        />
      </Box>
    </Card>
  );
}
